export const StoryblokConfig = {
  accessToken: process.env.STORYBLOK_TOKEN || 's5q3k3tznbONlPsX9DONuwtt',
  startPageSlug: 'index',
  defaultLocale: 'sv',
  revalidate: 3600,
}
